import { render } from "./commonPatientShareTemplate.vue?vue&type=template&id=41628186"
import script from "./commonPatientShareTemplate.vue?vue&type=script&lang=js"
export * from "./commonPatientShareTemplate.vue?vue&type=script&lang=js"

import "./commonPatientShareTemplate.vue?vue&type=style&index=0&id=41628186&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__